const sourceParamsEditActions = {
  SOURCE_PARAMS_EDIT_SET: 'SOURCE_PARAMS_EDIT_SET',
  SOURCE_PARAM_UPDATE: 'SOURCE_PARAM_UPDATE',
};
export default sourceParamsEditActions;
